import { OffresJsonldOffreReadVisibiliteEnum } from '@europrocurement/l2d-domain/openApi/ApiOffre';
import { IconName, findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import { z } from 'zod';

/**
 * Préfixe FontAwesome réellement enregistré dans la library (cf. l2d-icons/index.ts)
 * et utilisé pour le rendu par FaOptionIcon. La validation des icônes doit donc
 * cibler ce même préfixe.
 */
const ICON_PREFIX = 'fasr' as const;

/** Zod schema used for form validation and error feedbacks */

const maxLenghtMessage = (max: number) => `Ce champs est limité à ${max} caractères`;
const requiredMessage = 'Le champs est obligatoire';

const offerVisibilityAvailableValues = OffresJsonldOffreReadVisibiliteEnum;

export const offerSchema = z.object({
    label: z.string().trim().min(1, requiredMessage).max(50, maxLenghtMessage(50)),
    visibility: z.enum([
        offerVisibilityAvailableValues.Full,
        offerVisibilityAvailableValues.Partial,
    ]),
    domainId: z.number(),
    iconeName: z
        .string()
        .trim()
        .refine(
            (value) =>
                value === '' ||
                !!findIconDefinition({ prefix: ICON_PREFIX, iconName: value as IconName }),
            {
                message: 'Icône invalide',
            },
        ),
    calculCombineId: z.number(),
    calculMultipleId: z.number(),
    origineIds: z.array(
        z.object({
            value: z.number(),
            label: z.string(),
        }),
    ),
});

export type OfferSchema = z.infer<typeof offerSchema>;
